
export class EmailFournisseurDTO{
    
    token: string;
    idBc: number;
    fournisseurEmail: string;
    objetEmail: string;
    corpsEmail: string;
    // Ajouter un type blop pour le pdf
    document: File;
}
